import { useState, useEffect, useCallback } from 'react';
import { Card, Table, Tag, Spin, message } from 'antd';
import { audit } from '../../services/api';

export default function AuditPage() {
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const loadLogs = useCallback(async (p = page, ps = pageSize) => {
    setLoading(true);
    try {
      const res = await audit.logs({ page: p, pageSize: ps });
      setLogs(res.data || []);
      setTotal(res.total || 0);
      setPage(res.page || p);
      setPageSize(res.pageSize || ps);
    } catch (err) {
      message.error(err.message || '仅管理员可查看操作日志');
    } finally {
      setLoading(false);
    }
  }, [page, pageSize]);

  useEffect(() => { loadLogs(1, 20); }, []);

  const columns = [
    { title: '时间', dataIndex: 'created_at', width: 180, render: v => v ? new Date(v).toLocaleString('zh-CN') : '-' },
    { title: '操作人', dataIndex: 'username', width: 100 },
    { title: '模块', dataIndex: 'module', width: 100, render: v => <Tag>{v}</Tag> },
    { title: '操作', dataIndex: 'action' },
    { title: '结果', dataIndex: 'result', width: 80, render: v => <Tag color={v === '成功' ? 'green' : 'red'}>{v}</Tag> },
    { title: 'IP', dataIndex: 'ip_address', width: 130 },
  ];

  if (loading && logs.length === 0) return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;

  return (
    <Card title={`操作审计日志（共 ${total} 条）`} size="small">
      <Table
        columns={columns}
        dataSource={logs.map(l => ({ ...l, key: l.id }))}
        loading={loading}
        pagination={{
          current: page,
          pageSize,
          total,
          showSizeChanger: true,
          showTotal: (t) => `共 ${t} 条`,
          onChange: (p, ps) => loadLogs(p, ps),
        }}
        size="small"
        scroll={{ x: 900 }}
      />
    </Card>
  );
}
